module.exports = __webpack_public_path__ + "static/media/ys.80bad204.png";